import { TTheme } from "../models/types/Theme.types";

export const SITE_NAME = process.env.REACT_APP_SITE_NAME as string;
export const SITE_URL = process.env.REACT_APP_SITE_URL as string;
export const ABOUT_URL = process.env.REACT_APP_ABOUT_URL as string;
export const CONTACT_URL = process.env.REACT_APP_CONTACT_URL as string;
export const SITE_DESCRIPTION = process.env
  .REACT_APP_SITE_DESCRIPTION as string;
export const SITE_FAVICON = process.env.REACT_APP_SITE_FAVICON as string;
export const SITE_LOGO = process.env.REACT_APP_SITE_LOGO as string;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID as string;
// Client number sent to the API. Defaults to CLIENT_ID; REACT_APP_API_CLIENT_ID points the API
// at another client's backend (e.g. the testing server) while this client's UI is kept.
export const API_CLIENT_ID = (process.env.REACT_APP_API_CLIENT_ID ||
  CLIENT_ID) as string;
export const BACKEND_URL_PROTOCOL = process.env
  .REACT_APP_BACKEND_URL_PROTOCOL as string; // http:// or https://
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL as string; // Without https:// or http:// prefix
export const API_VERSION = process.env.REACT_APP_API_VERSION as string;
export const THEME: TTheme = "default";
export const BACKEND_URL_INVENTORY = process.env
  .REACT_APP_BACKEND_URL_INVENTORY as string;
export const APPLY_SHORT_URL = process.env.REACT_APP_APPLY_SHORT_URL as string;
export const HERO_SECTION_BG = process.env.REACT_APP_HERO_SECTION_BG as string;
export const THEME_COLOR = process.env.REACT_APP_THEME_COLOR as string;
export const HAS_BANNER_CTA = process.env.REACT_APP_HAS_BANNER_CTA as string;
export const HAS_PROGRAM_CARD_CTA = process.env
  .REACT_APP_HAS_PROGRAM_CARD_CTA as string;
export const MAIN_URL = process.env.REACT_APP_MAIN_URL as string;
export const APP_VERSION_CODE = Number(process.env.REACT_APP_VERSION_CODE) || 1;

